import * as yup from "yup";
import { t } from "i18next";

export const subRestrictionValidateSchema = yup.object().shape({
  acc_no: yup.string().required(() => t("forms:invalid-account-code")),
  dept: yup.string(),
  credit: yup.string().when("dept", {
    is: "",
    then: yup.string().required(() => t("forms:enter-debit-or-credit")),
  }),
});

export const restrictionValidateSchema = yup.object().shape({
  // doc_no2: yup.string().required("doc_no2 not found"),
  total_dept: yup.number().required(),
  // .moreThan(
  //       0.00,
  //       `No accounts`),

  total_credit: yup
    .number()
    .oneOf([yup.ref("total_dept"), null], () => t("forms:unbalanced-restriction")),
});
